import Users from 'src/api/users.js'
import { Channel } from 'src/store/models/index.js'
import userNotificationHandler from 'src/config/services/userNotificationHandler.js'

const defaultState = () => ({
  userChannels: {},
  unreadMessages: 0,
  typingUsers: [],
  typingTimeout: {}
})

export const state = defaultState()

const clearTypingTimeouts = (state) => {
  Object.values(state.typingTimeout).forEach(timeout => clearTimeout(timeout))
}

export const mutations = {
  RESET_STATE (state) {
    // pending typing timeouts would otherwise fire on the fresh state (e.g. after logout)
    clearTypingTimeouts(state)
    Object.assign(state, defaultState())
  },
  SET_USER_CHANNELS (state, { userId, channelIds }) {
    state.userChannels = {
      ...state.userChannels,
      [userId]: channelIds
    }
  },
  SET_UNREAD_COUNT (state, { count }) {
    state.unreadMessages = count
  },
  SET_TYPING_USERS (state, { typingUsers }) {
    state.typingUsers = [...typingUsers]
  },
  CLEAR_TYPING_TIMEOUT (state, { typingUserName }) {
    clearTimeout(state.typingTimeout[typingUserName])
  },
  RESET_TYPING_USERS (state) {
    clearTypingTimeouts(state)
    state.typingTimeout = {}
    state.typingUsers = []
  },
  SET_TYPING_TIMEOUT (state, { typingUserName, callback }) {
    const _state = state
    state.typingTimeout[typingUserName] = setTimeout(function () {
      callback()
    }, 2000)
  }
}

export const getters = {
  TYPING_USERS (state) {
    return state.typingUsers
  },
}

export const actions = {
  updateTypingUsers ({ state, commit }, { typingUserId, channelId }) {
    if (!typingUserId || !channelId) return

    const channel = Channel.find(channelId)
    if (!channel?.meta?.participants) return

    const typingUserName = channel.meta.participants[typingUserId]
    commit('CLEAR_TYPING_TIMEOUT', { typingUserName })

    const callback = () => {
      commit('SET_TYPING_USERS', { typingUsers: state.typingUsers.filter(el => el !== typingUserName) })
    }

    commit('SET_TYPING_TIMEOUT', { typingUserName, callback })

    if (state.typingUsers.includes(typingUserName)) return
    commit('SET_TYPING_USERS', {typingUsers: [...state.typingUsers, typingUserName]})
  },

  async updateUnreadCount ({ commit }, unreadCount) {
    commit('SET_UNREAD_COUNT', { count: unreadCount })
    if (unreadCount > 0) return
    // clear page title interval (* blinking)
    userNotificationHandler.clearPageTitleInterval()
  },
  async getUsersChannels ({ state, commit }, { userId, page, ids }) {
    const res = await Users.getChannelsPaginated(userId, page)
    const oldChannelIds = state.userChannels[userId] || []

    let channelIds = res.data.map(channel => channel.id)
    channelIds = [...channelIds, ...ids]
    commit('SET_USER_CHANNELS', { channelIds, userId })

    const deletedChannels = oldChannelIds.filter(id => !channelIds.includes(id))
    Channel.delete(record => deletedChannels.includes(record.id))

    Channel.insertOrUpdate({ data: res.data })
    return res
  }
}
